var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"temp-image",staticStyle:{"width":"100%","height":"100vh","object-fit":"cover","object-position":"top center"},attrs:{"src":this.$appConfig.imagesUrl + 'fitness-diary/coming-soon.jpg'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }